import { Bridge, BridgeFilters, BridgeType, BridgeTypeFormValues, BridgeFieldLabels } from "../../../api/Bridges";
import { DefinedPropertyObject, IEntityMinimalModel } from "../../../api/GenericTypes";
import { SelectFormField } from "../../../common/formfields/SelectFormField";
import { DatasetsVirtualizedSelectForm } from "../../../common/forms/EntityForms/formsVirtualized/DatasetsVirtualizedSelectForm";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import { CombinedModificationRecordEntityFilterForm } from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { defaultBridgesFilters } from "./BridgesTable";

export interface BridgeFilterForm extends ICombinedModificationRecordEntityForm {
  types?: { id: BridgeType; name: string }[] | undefined | null;
  datasetIds?: IEntityMinimalModel[] | undefined | null;
}

const defaultValues: DefinedPropertyObject<BridgeFilterForm> = {
  types: null,
  datasetIds: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
};

export const bridgesFormToFilters = (form: BridgeFilterForm): BridgeFilters => {
  let filters: BridgeFilters = { ...combinedModificationRecordEntityFormToFilters(form) };
  filters.types = Array.isArray(form.types) && form.types.length > 0 ? form.types?.map((d) => d.id) : null;
  filters.datasetIds =
    Array.isArray(form.datasetIds) && form.datasetIds.length > 0 ? form.datasetIds?.map((d) => d.id) : null;
  return filters;
};
/**
 * Converts BridgeFilters to BridgeFilterForm
 * @param filters BridgeFilters
 * @returns BridgeFilterForm
 * @author @CorradoSurmanowicz
 */
export const bridgesFiltersToForm = (filters: BridgeFilters): BridgeFilterForm => {
  let form: BridgeFilterForm = { ...combinedModificationRecordEntityFiltersToForm(filters) };
  form.types = filters.types ? filters.types.map((id) => ({ id, name: "" })) : null;
  form.datasetIds = filters.datasetIds ? filters.datasetIds.map((id) => ({ id, name: "" })) : null;
  return form;
};

export const BridgeFilterBar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<Bridge, BridgeFilterForm, BridgeFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultBridgesFilters}
      formToFilters={bridgesFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <SelectFormField
            id="types"
            label={BridgeFieldLabels.type}
            control={control}
            items={BridgeTypeFormValues}
            placeholder="Select connection type..."
            horizontal={false}
            isMulti
          />

          <DatasetsVirtualizedSelectForm id="datasetIds" label={BridgeFieldLabels.datasets} control={control} isMulti />

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
